module.exports = __webpack_public_path__ + "static/media/mountains-phone.f1731047.png";